module.exports = __webpack_public_path__ + "img/t1.26ca21e9.png";